export const defaultModelData = {
  init: false
};

export const ActionType = {
  INIT: `init`,
  DESCTROY: `destroy`
};

export const ANIMATION_DURATION = 500;
